module.exports = __webpack_public_path__ + "static/media/EU_logo.2158c81c.svg";